import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import "./toolbar.css";
const toolbar = (props) => (
  <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top">
    <Navbar.Brand href="https://programmersarmy.com/">
       
      <img
        src="/image/logo.svg"
        width="185"
        height="60"
        className="d-inline-block align-top"
        alt="Programmers Army"
      />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="mr-auto"></Nav>
      <Nav className="navitems">
        <a href="https://programmersarmy.com/">Home</a>
        <a href="#contributors">Contributors</a>
        <a href="https://programmersarmy.com/aboutus.html">About Us</a>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);

export default toolbar;
